import React from 'react'
import PanelSearchEmail from '../search/PanelSearchEmail'
import TablePlanSearch from './TablePlanSearch'

function PanelPlanSearchEmail({
  email,
}) {
  return (
    <PanelSearchEmail
      email={email}
      TableComponent={TablePlanSearch} />
  )
}

export default (PanelPlanSearchEmail)